module.exports = __webpack_public_path__ + "img/24_56.e4475624.png";